'use client';

import { c as _c } from "react/compiler-runtime";
import { updateCouponSettings, type UpdateCouponSettingsResponse } from '@svs/nova-poolbetting/core/action/coupon';
import { useCouponSettings, useUpdateCouponSettings } from '@svs/nova-poolbetting/core/nextjs/coupon';
import { useEngine } from '@svs/nova-poolbetting/core/nextjs/engine';
import type { SettingsKeys } from '@svs/nova-poolbetting/schema/sessionstore';
import type { ReactNode } from 'react';
import CouponSettingsForm from './CouponSettingsForm';
type CouponSettingsContainerProps = {
  settingsKey: SettingsKeys;
};

/**
 * Coupon settings form items.
 *
 * @param root0 Component props
 * @param root0.settingsKey Settings key, to get settings for either play or my bets/results
 * @returns React component for coupon setting form items
 */
export default function CouponSettingsContainer(t0) {
  const $ = _c(11);
  const {
    settingsKey
  } = t0;
  const definition = useEngine();
  const couponSettings = useCouponSettings(definition.moduleEngine, settingsKey);
  const updateCouponSettingsApi = useUpdateCouponSettings(definition.moduleEngine, settingsKey);
  let userSettings = couponSettings.data;
  if (couponSettings.isError) {
    userSettings = definition.defaultCouponSettingsValues;
  }
  let t1;
  if ($[0] !== definition.moduleEngine || $[1] !== settingsKey) {
    t1 = async (previousState, formData) => updateCouponSettings({
      product: definition.moduleEngine,
      previousState,
      formData,
      settingsKey
    });
    $[0] = definition.moduleEngine;
    $[1] = settingsKey;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const boundUpdateCouponSettings = t1;
  let tipsInfo = definition.tipsinfoOptions;
  if (settingsKey !== "PLAY") {
    let t2;
    if ($[3] !== tipsInfo) {
      t2 = tipsInfo.filter(_temp);
      $[3] = tipsInfo;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    tipsInfo = t2;
  }
  let t2;
  if ($[5] !== boundUpdateCouponSettings || $[6] !== settingsKey || $[7] !== tipsInfo || $[8] !== updateCouponSettingsApi || $[9] !== userSettings) {
    t2 = <CouponSettingsForm mutationApi={updateCouponSettingsApi} action={boundUpdateCouponSettings} userSettings={userSettings} tipsinfo={tipsInfo} settingsKey={settingsKey} />;
    $[5] = boundUpdateCouponSettings;
    $[6] = settingsKey;
    $[7] = tipsInfo;
    $[8] = updateCouponSettingsApi;
    $[9] = userSettings;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}
function _temp(option) {
  return option === "Odds" || option === "SvenskaFolket" || option === "FavoriteOdds";
}